import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { callServiceAndFormulateLogMessageResult } from './messageHandlingUtils';
import { callServiceAndFormulateAppMessageResult, onStatusError } from './messageHandlingUtils';
/**
 * Responsible for handling conversations messages
 */
var ConversationsMessageHandler = /** @class */ (function (_super) {
    __extends(ConversationsMessageHandler, _super);
    function ConversationsMessageHandler(appSdkHost, conversationsService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.conversationsService = conversationsService;
        return _this;
    }
    ConversationsMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.conversations.openConversation, function (_, params) {
            _this.conversationsService.clearListeners();
            _this.conversationsService.addEventListener('startConversation', function (event) {
                return _this.appSdkHost.sendRequestMessage('startConversation', event.data
                    ? [event.data.subEntityId, event.data.conversationId, event.data.channelId, event.data.entityId]
                    : []);
            });
            _this.conversationsService.addEventListener('closeConversation', function (event) {
                return _this.appSdkHost.sendRequestMessage('closeConversation', event.data
                    ? [event.data.subEntityId, event.data.conversationId, event.data.channelId, event.data.entityId]
                    : []);
            });
            return callServiceAndFormulateAppMessageResult(_this.conversationsService.openConversation, params);
        }, {
            errorCallback: function (error, scenario) { return onStatusError(SdkMessageTypes.links.openLink, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.conversations.closeConversation, function (_) {
            _this.conversationsService.clearListeners();
            return callServiceAndFormulateLogMessageResult(_this.conversationsService.closeConversation);
        }, {});
        this.registerHandler(SdkMessageTypes.conversations.getChatMembers, function (_) { return callServiceAndFormulateAppMessageResult(_this.conversationsService.getChatMembers); }, {
            isRestrictedToFullTrustApps: true,
        });
    };
    ConversationsMessageHandler.prototype.validateDependencies = function () {
        if (!this.conversationsService) {
            throw 'No ConversationsService provided';
        }
    };
    return ConversationsMessageHandler;
}(BaseMessageHandler));
export { ConversationsMessageHandler };
//# sourceMappingURL=conversations-message-handler.js.map